import { useDispatch, useSelector } from "react-redux";
import { useDropdownConfig } from "../../../../contexts/DropdownsContext";
import { cancelEdit, cancelEdition, currencyChange, fetchTATInfo, saveVendor, selectAllVendorConditions, selectCostType, selectEditingStatus, selectGeneralConditions, selectLoading, selectPartVendors, selectSelectedVendor, selectVendorConditions, startEdition, vendorChange } from "../../../../redux/features/configuration/parts/vendorCostSlice";
import { useEffect, useState } from "react";
import Dropdowns from "../../../../components/Dropdowns/Dropdowns";
import MultioptionButton from "../../../../components/Buttons/MultioptionButton";
import { VendorTabs } from "./VendorTabs";
import { useSnackBar } from "../../../../hooks/useSnackBar";
import { HTTP_RESPONSE_CODES } from "../../../../globals/globals";
import { useAlert } from "../../../../hooks/useAlert";
// import './VendorsCost.css';

export const VendorContent = ({ part, vendorIdx }) => {
    const currencyDrpdwn = useDropdownConfig(74);
    const vendorDrpdwn = useDropdownConfig(94);
    const selectedVendor = useSelector(selectSelectedVendor);
    const editingStatus = useSelector(selectEditingStatus);
    const partConditions = useSelector(selectGeneralConditions);
    const costType = useSelector(selectCostType);
    const [companyParameter, _] = useState([{ "columnName": "companyId", value: parseInt(localStorage.getItem('u_company_id')) }]);
    const dispatch = useDispatch();
    const { successMsg, warningMsg, infoMsg } = useSnackBar();
    const { successAlert, errorAlert, infoAlert, warningAlert } = useAlert();
    const vendors = useSelector(selectPartVendors);
    const loading = useSelector(selectLoading);



    const updateVendorVendor = (newVendor) => {
        dispatch(vendorChange({ newVendor }))

    }
    const updateVendorCurrency = (newCurrency) => {
        dispatch(currencyChange({ newCurrency }));

    }

    useEffect(() => {
    }, [part])

    const vendorConditions = useSelector(selectAllVendorConditions)
    const saveClick = (closeEdition) => {
        if (vendorConditions[selectedVendor.tempId]?.length > 0) {


            dispatch(saveVendor({
                vendorTempId: selectedVendor.tempId, partId: part.id, closeEdition
            })).then(action => {


                if (action.payload) {
                    let { conditionResponses, vendorTempId, closeEdition, prevConditions } = action.payload;
                    let title = "";
                    let errors = conditionResponses.reduce((acc, cr) => {
                        if ([HTTP_RESPONSE_CODES.CREATED, HTTP_RESPONSE_CODES.SUCCESS, HTTP_RESPONSE_CODES.UPDATED].includes(cr.data.responseCode)) {
                            return acc
                        } else {
                            title = title || cr.data.message;
                            return [...acc, `${cr.data.validationErrors?.map(e => e.error).join('<br>') ?? ""}`]
                        }
                    }
                        , []);
                    conditionResponses.forEach(cR => {
                        let crErrors = cR.data.load?.costResponses.reduce((acc, cresponse) => {
                            if ([HTTP_RESPONSE_CODES.CREATED, HTTP_RESPONSE_CODES.SUCCESS, HTTP_RESPONSE_CODES.UPDATED].includes(cresponse.data.responseCode)) {
                                return acc;
                            } else {
                                title = title || cresponse.data.message;
                                return [...acc, `${(cresponse.data.validationErrors ?? []).map(e => e.error).join('<br> ')}`]
                            }
                        }, []) ?? [];

                        errors = [...crErrors, ...errors].filter(e => Boolean(e));
                    });
                    if (Boolean(title)) {
                        if (errors.length > 0) {
                            errorAlert(title, errors.join("<br> "), { okClick: () => { } });
                        } else {
                            errorAlert("Error", title, { okClick: () => { } });
                        }
                    } else {
                        successMsg(costType === "C" ? "Vendor cost information saved" : "Vendor repair information saved");
                    }
                }
            })
        } else {
            errorAlert("Error", `Please add at least one ${costType === "C" ? "condition" : "repair type"}`, {});
        }

    }

    const startEditing = () => dispatch(startEdition({ vendorTempId: selectedVendor.tempId }))
    const cancelEditing = () => {
        // dispatch(cancelEdition({vendorTempId: selectedVendor.tempId}));
        dispatch(cancelEdit({ vendorTempId: selectedVendor.tempId })).then(action => {
            if (!action.payload.discardVendor) {
                dispatch(fetchTATInfo({ partId: part.id, vendorId: selectedVendor.vendorId, vendorTempId: selectedVendor.tempId, partConditions, costType }))
            }
            infoMsg(action.payload.msg);
        });
    }

    useEffect(() => {
        dispatch(fetchTATInfo({ partId: part.id, vendorId: selectedVendor.vendorId, vendorTempId: selectedVendor.tempId, partConditions, costType }))
    }, [selectedVendor?.tempId])


    return (<div className='right-container'>
        {/* {JSON.stringify(selectedVendor)} */}
        <div className='right-header'>
            <b>Vendor</b>
            {!loading && <><Dropdowns filterFn={v => !vendors.find(qV => qV.vendorId === v.id)} required disabled={!(editingStatus[selectedVendor.tempId])} preSelectValue={selectedVendor.vendorId} hideLabel optionLabel="name" onOptionSelect={(vendor) => updateVendorVendor(vendor)} data={vendorDrpdwn.config} parameters={companyParameter} />
                <span>Currency</span>
                <Dropdowns required disabled={!(editingStatus[selectedVendor.tempId])} onOptionSelect={(currency) => updateVendorCurrency(currency)} preSelectValue={selectedVendor.currencyId} hideLabel data={currencyDrpdwn.config} />
            </>}

            <div className='actions'>
                {(editingStatus[selectedVendor.tempId]) ?
                    <MultioptionButton buttons={saveButtons} buttonCallbacks={{
                        'save': () => saveClick(true),
                        'save-continue': () => saveClick(false),
                        'cancel': () => cancelEditing()
                    }}></MultioptionButton>
                    : <i onClick={() => startEditing()} className='icon-edit'></i>}
            </div>
        </div>
        <div className='tabs'>
            <VendorTabs part={part} vendorTempId={selectedVendor.tempId} />
            {/* <VendorTabs currency={currencies[currencyByVendor[selectedVendor?.tempId]]} costType={costType} vendor={selectedVendor} part={part} /> */}
        </div>
    </div>);
}

const saveButtons = [
    { label: 'Save and Finish', icon: "icon-save", id: 'save' },
    { label: 'Save and Continue Editing', icon: "icon-save", id: 'save-continue' },
    { label: 'Cancel', icon: "icon-cross", id: 'cancel', type: 'danger' }
];

